export const POST_LOGIN_REQUEST = "POST_LOGIN_REQUEST";
export const POST_LOGIN_SUCCESS = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_FAILURE = "POST_LOGIN_FAILURE";
export const POST_CONFIRM_LOGIN_REQUEST = "POST_CONFIRM_LOGIN_REQUEST";
export const POST_CONFIRM_LOGIN_SUCCESS = "POST_CONFIRM_LOGIN_SUCCESS";
export const POST_CONFIRM_LOGIN_FAILURE = "POST_CONFIRM_LOGIN_FAILURE";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const POST_FORGOT_USER_ID_REQUEST = "POST_FORGOT_USER_ID_REQUEST";
export const POST_FORGOT_USER_ID_SUCCESS = "POST_FORGOT_USER_ID_SUCCESS";
export const POST_FORGOT_USER_ID_FAILURE = "POST_FORGOT_USER_ID_FAILURE";
export const GET_CURRENT_USER_ID_REQUEST = "GET_CURRENT_USER_ID_REQUEST";
export const GET_CURRENT_USER_ID_SUCCESS = "GET_CURRENT_USER_ID_SUCCESS";
export const GET_CURRENT_USER_ID_FAILURE = "GET_CURRENT_USER_ID_FAILURE";
export const RESEND_OTP_REQUEST = "RESEND_OTP_REQUEST";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_FAILURE = "RESEND_OTP_FAILURE";
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_REQUEST_SUCCESS =
  "FORGOT_PASSWORD_REQUEST_SUCCESS";
export const FORGOT_PASSWORD_REQUEST_FAILURE =
  "FORGOT_PASSWORD_REQUEST_FAILURE";
export const VERIFY_FORGOT_PASS_OTP_REQUEST = "VERIFY_FORGOT_PASS_OTP_REQUEST";
export const VERIFY_FORGOT_PASS_OTP_SUCCESS = "VERIFY_FORGOT_PASS_OTP_SUCCESS";
export const VERIFY_FORGOT_PASS_OTP_FAILURE = "VERIFY_FORGOT_PASS_OTP_FAILURE";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const LOGIN_PORTAL_REQUEST = "LOGIN_PORTAL_REQUEST";
export const LOGIN_PORTAL_SUCCESS = "LOGIN_PORTAL_SUCCESS";
export const LOGIN_PORTAL_FAILURE = "LOGIN_PORTAL_FAILURE";
export const GET_AUTHORIZATION_AUTH = "GET_AUTHORIZATION_AUTH";
export const GET_AUTHORIZATION_AUTH_SUCCESS = "GET_AUTHORIZATION_AUTH_SUCCESS";
export const GET_AUTHORIZATION_AUTH_FAILURE = "GET_AUTHORIZATION_AUTH_FAILURE";

export const GET_MAINTENANCE_MSG = "GET_MAINTENANCE_MSG";
export const GET_MAINTENANCE_MSG_SUCCESS = "GET_MAINTENANCE_MSG_SUCCESS";
export const GET_MAINTENANCE_MSG_FAILURE = "GET_MAINTENANCE_MSG_FAILURE";

export const GENERATE_LOGIN_OTP = "GENERATE_LOGIN_OTP";
export const GENERATE_LOGIN_OTP_SUCCESS = "GENERATE_LOGIN_OTP_SUCCESS";
export const GENERATE_LOGIN_OTP_FAILURE = "GENERATE_LOGIN_OTP_FAILURE";


export const postLoginRequest = (
  userID,
  password,
  authClientID,
  authRedirectUrl,
  authState,
  recaptchaToken,
  code,
  twoFAReferenceCode

) => ({
  type: "POST_LOGIN_REQUEST",
  userID,
  password,
  authClientID,
  authRedirectUrl,
  authState,
  recaptchaToken,
  code,
  twoFAReferenceCode
});

export const postLoginSuccess = (data) => ({
  type: "POST_LOGIN_SUCCESS",
  data,
});

export const postLoginFailure = (message) => ({
  type: "POST_LOGIN_FAILURE",
  message,
});

export const postConfirmLoginRequest = (
  loginRequestKey,
  twoFAReferenceCode
) => ({
  type: "POST_CONFIRM_LOGIN_REQUEST",
  loginRequestKey,
  twoFAReferenceCode,
});

export const postConfirmLoginSuccess = (data) => ({
  type: "POST_CONFIRM_LOGIN_SUCCESS",
  data,
});

export const postConfirmLoginFailure = (message) => ({
  type: "POST_CONFIRM_LOGIN_FAILURE",
  message,
});

export const setAuthToken = (authToken) => ({
  type: "SET_AUTH_TOKEN",
  authToken,
});

//Forgot User ID Request
export const postForgotUserIdRequest = (userID, birthdate,recaptchaToken) => ({
  type: "POST_FORGOT_USER_ID_REQUEST",
  userID,
  birthdate,
  recaptchaToken
});

export const postForgotUserIdSuccess = (data) => ({
  type: "POST_FORGOT_USER_ID_SUCCESS",
  data,
});

export const postForgotUserIdFailure = (message) => ({
  type: "POST_FORGOT_USER_ID_FAILURE",
  message,
});

//Get Current User Id Request
export const getCurrentUserIdRequest = (userID, code2Fa, otpReference) => ({
  type: "GET_CURRENT_USER_ID_REQUEST",
  userID,
  code2Fa,
  otpReference,
});

export const getCurrentUserIdSuccess = (data) => ({
  type: "GET_CURRENT_USER_ID_SUCCESS",
  data,
});

export const getCurrentUserIdFailure = (message) => ({
  type: "GET_CURRENT_USER_ID_FAILURE",
  message,
});

//Resend Otp
export const resendOtpRequest = (userID,recaptchaToken) => ({
  type: "RESEND_OTP_REQUEST",
  userID,
  recaptchaToken
});

export const resendOtpSuccess = (data) => ({
  type: "RESEND_OTP_SUCCESS",
  data,
});

export const resendOtpFailure = (message) => ({
  type: "RESEND_OTP_FAILURE",
  message,
});

//Forgot Password
export const forgotPasswordRequest = (userID, birthdate,recaptchaToken) => ({
  type: "FORGOT_PASSWORD_REQUEST",
  userID,
  birthdate,
  recaptchaToken
});

export const forgotPasswordRequestSuccess = (data) => ({
  type: "FORGOT_PASSWORD_REQUEST_SUCCESS",
  data,
});

export const forgotPasswordRequestFailure = (message) => ({
  type: "FORGOT_PASSWORD_REQUEST_FAILURE",
  message,
});

//Verify Forgot Password Otp
export const verifyForgotPassOtpRequest = (code2Fa, otpReference) => ({
  type: "VERIFY_FORGOT_PASS_OTP_REQUEST",
  code2Fa,
  otpReference,
});

export const verifyForgotPassOtpSuccess = (data) => ({
  type: "VERIFY_FORGOT_PASS_OTP_SUCCESS",
  data,
});

export const verifyForgotPassOtpFailure = (message) => ({
  type: "VERIFY_FORGOT_PASS_OTP_FAILURE",
  message,
});

//Change password Req
export const changePasswordRequest = (
  userID,
  password,
  confirmPassword,
  otpReference
) => ({
  type: "CHANGE_PASSWORD_REQUEST",
  userID,
  password,
  confirmPassword,
  otpReference,
});

export const changePasswordSuccess = (data) => ({
  type: "CHANGE_PASSWORD_SUCCESS",
  data,
});

export const changePasswordFailure = (message) => ({
  type: "CHANGE_PASSWORD_FAILURE",
  message,
});

//Login Portal
export const loginPortalRequest = (
  actionId,
  authClientId,
  authRedirectUrl,
  authState
) => ({
  type: "LOGIN_PORTAL_REQUEST",
  actionId,
  authClientId,
  authRedirectUrl,
  authState,
});

export const loginPortalSuccess = (data) => ({
  type: "LOGIN_PORTAL_SUCCESS",
  data,
});

export const loginPortalFailure = (message) => ({
  type: "LOGIN_PORTAL_FAILURE",
  message,
});

//Get Authorization Auth Code
export const getAuthorizationAuth = (authState, authRedirectUrl) => ({
  type: "GET_AUTHORIZATION_AUTH",
  authState,
  authRedirectUrl,
});

export const getAuthorizationAuthSuccess = (data) => ({
  type: "GET_AUTHORIZATION_AUTH_SUCCESS",
  data,
});

export const getAuthorizationAuthFailure = (message) => ({
  type: "GET_AUTHORIZATION_AUTH_FAILURE",
  message,
});

//Auth Token
export const GET_AUTH_TOKEN_REQUEST = "GET_AUTH_TOKEN_REQUEST";
export const GET_AUTH_TOKEN_SUCCESS = "GET_AUTH_TOKEN_SUCCESS";
export const GET_AUTH_TOKEN_FAILURE = "GET_AUTH_TOKEN_FAILURE";

export const getAuthTokenRequest = (nric) => ({
  type: "GET_AUTH_TOKEN_REQUEST",
  nric,
});

export const getAuthTokenSuccess = (data) => ({
  type: "GET_AUTH_TOKEN_SUCCESS",
  data,
});

export const getAuthTokenFailure = (message) => ({
  type: "GET_AUTH_TOKEN_FAILURE",
  message,
});

//Auth Token
export const GET_SINGPASS = "GET_SINGPASS";
export const GET_SINGPASS_SUCCESS = "GET_SINGPASS_SUCCESS";
export const GET_SINGPASS_FAILURE = "GET_SINGPASS_FAILURE";

export const getSingPass = (authState, authCode) => ({
  type: "GET_SINGPASS",
  authState,
  authCode,
});

export const getSingPassSuccess = (data) => ({
  type: "GET_SINGPASS_SUCCESS",
  data,
});

export const getSingPassFailure = (message) => ({
  type: "GET_SINGPASS_FAILURE",
  message,
});

export const getMaintenanceMsg = () => ({
type: "GET_MAINTENANCE_MSG",
});

export const getMaintenanceMsgSuccess = (data) => ({
  type: "GET_MAINTENANCE_MSG_SUCCESS",
  data,
});

export const getMaintenanceMsgFailure = (message) => ({
  type: "GET_MAINTENANCE_MSG_FAILURE",
  message,
});

//generate otp req
export const generateLoginOtp = (submitData) => ({
  type: "GENERATE_LOGIN_OTP",
  submitData,
});
export const generateLoginOtpSuccess = (data) => ({
  type: "GENERATE_LOGIN_OTP_SUCCESS",
  data,
});
export const generateLoginOtpFailure = (message) => ({
  type: "GENERATE_LOGIN_OTP_FAILURE",
  message,
});
